import { ActivationStatus } from '@/app/shared/enums';
import { Model } from '@/app/shared/models/model';

export class ServiceActivationModel extends Model {
  public MonthReference!: number;
  public YearReference!: number;
  public Status!: ActivationStatus;
  public StartDate!: Date;
  public FinishDate!: Date;
  public Message!: string;
}
